var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('json-viewer',{staticClass:"json-view-focused",attrs:{"theme":"json-viewer-gruvbox-dark","expand-depth":9,"value":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }